export const END_USER_PURCHASE_NUMBER = 'END_USER_PURCHASE_NUMBER';
